<template>
    <div class="my-farmers">
        <div class="map-section">
            <custom-map ref="myFarmerMap" @getBounds="setViewBoundsFromMap" />
            <div class="components flex">
                <div v-if="!showfollwerlist" class="ml-2 my-followers-card">
                    <div class="head flex mb-3">
                        <h4 class="secondary-font">My Followers</h4>
                        <div class="flex ml-6">
                            <button @click="showfilter()" class="add-btn">
                                + Add Filter
                            </button>
                            <div class="ml-3">
                                <v-icon
                                    size="20"
                                    class="expand-icon"
                                    @click="showfollwerlist = true"
                                    >mdi-fullscreen</v-icon
                                >
                            </div>
                        </div>
                    </div>

                    <div class="list-container">
                        <div
                            v-for="follower in followerslist"
                            :key="follower.id"
                        >
                            <div
                                @click="setfarmerdata(follower)"
                                class="list flex my-2"
                            >
                                <img
                                    v-if="follower.image"
                                    class="mr-3"
                                    :src="follower.image.small"
                                    alt=""
                                />
                                <img
                                    v-else
                                    class="mr-3"
                                    src="https://cdn.pixabay.com/photo/2015/03/04/22/35/avatar-659652_960_720.png"
                                    alt=""
                                />
                                <p class="bold secondary-font">
                                    {{ follower.full_name }}
                                </p>
                            </div>
                        </div>
                        <farmer-details
                            :data="farmerdata"
                            :dialog="showfarmerdetails"
                            @close="showfarmerdetails = false"
                        />
                    </div>
                    <v-progress-linear
                        indeterminate
                        height="4"
                        class="mt-1 loader"
                        color="#1F8F58"
                        v-if="isdatapresent"
                    ></v-progress-linear>
                </div>

                <div v-if="showfollwerlist === true" class="all-followers-card">
                    <followers-list
                        @followercount="getfollowercount"
                        :showMenu="isFilterBtnClicked"
                        @close="closeList()"
                        @filtercliked="callMapApi()"
                    />
                </div>

                <div class="button-container flex">
                    <div>
                        <div
                            v-for="(broadcast, index) in broadcastType"
                            :key="index"
                            style="background: transparent"
                            class="options mb-3"
                            v-show="showBroadcastOptions"
                        >
                            <div class="flex">
                                <img
                                    v-if="
                                        broadcast.broadcast_type ===
                                        'outbound_calls'
                                    "
                                    :src="outbound_calls"
                                    alt=""
                                />
                                <img
                                    v-if="
                                        broadcast.broadcast_type ===
                                        'krishify_chat'
                                    "
                                    :src="krishify_chat"
                                    alt=""
                                />
                                <img
                                    v-if="broadcast.broadcast_type === 'sms'"
                                    :src="sms"
                                    alt=""
                                />
                                <img
                                    v-if="
                                        broadcast.broadcast_type === 'whatsapp'
                                    "
                                    :src="whatsapp"
                                    alt=""
                                />
                                <div
                                    class="--font bold pointer"
                                    @click="
                                        openBroadcastDialog(
                                            `${broadcast.broadcast_type}`
                                        )
                                    "
                                >
                                    {{ broadcast.display_text }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="broadcast-card pointer flex"
                            :class="{ active: showBroadcastOptions }"
                            @click="
                                showBroadcastOptions = !showBroadcastOptions
                            "
                        >
                            <div class="broadcast-image flex mx-2">
                                <img :src="broadcast" alt="" />
                            </div>
                            <h1 class="broadcast secondary-font mr-3">
                                Broadcast
                            </h1>
                        </div>

                        <div class="my-farmers-card mt-3">
                            <small class="--green --weight"> My Farmers </small>
                            <h1 class="secondary-font">{{ followerscount }}</h1>
                        </div>
                    </div>

                    <div></div>
                </div>
            </div>
        </div>

        <brodcast-modal
            :dialog="broadcastDialog"
            :headings="broadcastHeading"
            @close="broadcastDialog = false"
        />
    </div>
</template>

<script>
import broadcastModal from "./components/broadcast-modal.vue";
import followersList from "./components/followers-list.vue";
import farmerDetails from "./components/farmer-details.vue";
import API_URL from "../../../helpers/apiUrls";
import accessToken from "../../../helpers/accessToken";
import { mapActions } from "vuex";
import customMapFarmer from "./components/gmap.vue";


export default {
    ...mapActions("StateFilterStore", [
        "addstatedata",
        "removestateid",
        "GET_STATE_ID",
    ]),
    name: "products",

    data() {
        return {
            broadcast: require("../../../assets/MainDashboard/MyFarmers/Broadcast.svg"),
            outbound_calls: require("../../../assets/MainDashboard/MyFarmers/Calls.svg"),
            krishify_chat: require("../../../assets/MainDashboard/MyFarmers/KrishifyChat.svg"),
            sms: require("../../../assets/MainDashboard/MyFarmers/sms.svg"),
            whatsapp: require("../../../assets/MainDashboard/MyFarmers/Whatsapp.svg"),

            showBroadcastOptions: false,
            broadcastDialog: false,
            showfollwerlist: false,
            showfarmerdetails: false,
            filterdialog: false,
            isFilterBtnClicked: false,
            farmerdata: {},
            broadcastHeading: {
                heading: "",
                placeholder: "",
                note: "",
                type: "",
                button: "",
            },
            business_id: "",
            locations: [
                {
                    position: {
                        lat: 15.317277,
                        lng: 75.71389,
                    },
                },
                {
                    position: {
                        lat: 10.850516,
                        lng: 76.27108,
                    },
                },
                {
                    position: {
                        lat: 28.207609,
                        lng: 79.82666,
                    },
                },
                {
                    position: {
                        lat: 26.244156,
                        lng: 92.537842,
                    },
                },
                {
                    position: {
                        lat: 29.065773,
                        lng: 76.040497,
                    },
                },
                {
                    position: {
                        lat: 19.601194,
                        lng: 75.552979,
                    },
                },
                {
                    position: {
                        lat: 28.207609,
                        lng: 79.82666,
                    },
                },
            ],
            marker: require("../../../assets/MainDashboard/MyFarmers/mapMarker.svg"),
            followerslist: [],
            broadcastType: [],
            followerscount: 0,
            stateparams: "",
            isdatapresent: false,
            zoom: null,
            viewBounds: null,
            markerCluster: null,
            markerPoint: null,
            setPrecision: 6,
            viewBoundsPayload: null,
        };
    },

    mounted() {
        this.business_id = accessToken.getCredentials().brandID;
        this.$store.dispatch("StateFilterStore/removestateid");
        this.getFollowerslist();
        this.getBroadcastType();
        this.followerscount = this.followerslist.length;
        console.log(process.env.VUE_APP_API_BASE_URL_DISCOVERY);
        console.log(
            "refsValue",
            this.$refs.myFarmerMap.zoom,
            this.$refs.myFarmerMap.getViewBounds(),
            this.$store.getters["StateFilterStore/GET_STATE_ID"]
        );
        setTimeout(() => {
            this.getMapLocation(
                this.$refs.myFarmerMap.getViewBounds(),
                parseInt((this.$refs.myFarmerMap.zoom * 30) / 20)
            );
            this.zoom = this.zoom;
            this.setPrecision = parseInt(
                (this.$refs.myFarmerMap.zoom * 30) / 20
            );
            console.log("payload", this.zoom, this.setPrecision);
        }, 800);

        setTimeout(() => {
            this.viewBoundsPayload = this.$refs.myFarmerMap.getViewBounds();
            console.log(this.viewBoundsPayload);
        }, 400);
    },
    watch: {
        zoom: function (val) {
            console.log("zoom on main", val);
        },
    },

    methods: {
        evaluatePrecision(zoom) {
            if (zoom >= 8) {
                zoom -= 2;
            } else {
                zoom;
            }
            return zoom;
        },
        setViewBoundsFromMap(payload, zoom) {
            // const getzoom = this.evaluatePrecision(zoom);
            // console.log("payload", payload, zoom);
            // if (this.zoom === zoom) {

            // } else if (this.zoom < zoom) {
            //     this.setPrecision = this.setPrecision + 1;
            // } else if (this.setPrecision < 6) {
            //     this.setPrecision = 6;
            // } else {
            //     this.setPrecision = this.setPrecision - 1;
            // }

            const location = this.getMapLocation(payload, zoom);
            console.log("llllll", location, this.viewBoundsPayload);
            this.viewBoundsPayload = payload;
            this.zoom = zoom;
            this.$refs.myFarmerMap.addMarkers(location);
        },
        // call when filter cliced and removeed
        callMapApi() {
             this.$refs.myFarmerMap.zoom=4;
            console.log("IN CAKK MAO API");
            this.getMapLocation(this.viewBoundsPayload, 4);
            this.$refs.myFarmerMap.getViewBounds();
            console.log(
                "callMapApi===>",
                this.viewBoundsPayload,
                this.setPrecision
            );
        },
        getfollowercount(count) {
            console.log("COUNT", count);
            this.followerscount = count;
        },
        getMapLocation(payload, zoom) {
            console.log("payload====>", payload, zoom);
            this.toggleLoader(true);
            const successHandler = (response) => {
                if (response.status === 200) {
                    setTimeout(() => {
                        console.log("getMapLocation", response.data);

                        this.toggleLoader(false);
                        this.$refs.myFarmerMap.addMarkers(response.data);
                    }, 1000);
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.toggleLoader(false);
            };
            const data =
                this.$store.getters["StateFilterStore/GET_STATE_ID"].length > 0
                    ? {
                          brand_id: `${accessToken.getCredentials().brandID}`,
                          precision: zoom<=6?6:zoom+4,
                          states: this.$store.getters[
                              "StateFilterStore/GET_STATE_ID"
                          ],
                          view_bounds: payload,
                      }
                    : {
                          brand_id: `${accessToken.getCredentials().brandID}`,
                          precision:  zoom<=6?6:zoom+2,

                          view_bounds: payload,
                      };
            this.newRequestPOST(
                `${API_URL.followers_location}`,
                data,
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY
            );
            console.log("data===>", data);
            //return  followersData;
        },
        getfollowercount(count) {
            console.log("COUNT", count);
            this.followerscount = count;
        },

        reloadFollowerAPI() {
            this.stateparams = "";
            this.storedata =
                this.$store.getters["StateFilterStore/GET_STATE_ID"];

            if (this.storedata.length !== 0 && this.storedata.length !== 0) {
                for (var i = 0; i < this.storedata.length - 1; i++) {
                    this.stateparams += "&states=";
                    this.stateparams += this.storedata[i];
                }
                this.stateparams += "&states=";
                this.stateparams += this.storedata[this.storedata.length - 1];

                console.log(this.stateparams);
                this.getFollowerslist();
            } else {
                this.getFollowerslist();
            }
        },

        getBroadcastType() {
            this.toggleLoader(true);
            const successHandler = (response) => {
                this.toggleLoader(false);

                if (response.status === 200) {
                    this.broadcastType = response.data;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.toggleLoader(false);
            };

            this.requestGET(
                `${API_URL.broadcast_choice}`,
                {},
                {},
                successHandler,
                errorHandler,
                process.env.VUE_APP_API_BASE_URL_DISCOVERY
            );
        },

        setfarmerdata(follower) {
            this.showfarmerdetails = true;
            this.farmerdata = follower;
        },

        showfilter() {
            (this.showfollwerlist = true), (this.isFilterBtnClicked = true);
        },

        closeList() {
            this.showfollwerlist = false;
            this.isFilterBtnClicked = false;
            this.reloadFollowerAPI();
        },

        getFollowerslist() {
            // this.toggleLoader(true);
            this.isdatapresent = true;
            const successHandler = (response) => {
                // this.toggleLoader(false);
                this.isdatapresent = false;

                if (response.status === 200) {
                    console.log("res ", response.data.data);
                    this.followerslist = response.data.data;
                    this.followerscount = response.data.total_count;
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                // this.toggleLoader(false);
                this.isdatapresent = false;
            };

            this.requestGET(
                `${API_URL.myfarmer_followers}?business_id=${
                    this.business_id
                }&page=${1}&data_per_page=${30}${this.stateparams}`,
                {},
                {},
                successHandler,
                errorHandler,
               
            );
        },

        openBroadcastDialog(type) {
            switch (type) {
                case "outbound_calls":
                    this.broadcastHeading.heading =
                        "Broadcast to farmers through outbound calls";
                    this.broadcastHeading.placeholder =
                        "Write your message and we will create a professional recording for you...";
                    this.broadcastHeading.note =
                        "**Note : Krishify collects a nominal fee of ₹1 per 30 second audio for this service";
                    this.broadcastHeading.type = "outbound_calls";
                    this.broadcastHeading.button = "Broadcast Now";
                    break;
                case "sms":
                    this.broadcastHeading.heading =
                        "Broadcast to farmers through SMS";
                    this.broadcastHeading.placeholder =
                        "Write your message here...";
                    this.broadcastHeading.note =
                        "**Note : Krishify collects a nominal fee of ₹1 per SMS (140 characters) for this service";
                    this.broadcastHeading.type = "sms";
                    this.broadcastHeading.button = "Broadcast Now";
                    break;
                case "whatsapp":
                    this.broadcastHeading.heading =
                        "Broadcast users through WhatsApp";
                    this.broadcastHeading.placeholder =
                        "Write your message here...";
                    this.broadcastHeading.note =
                        "**Note : Krishify collects a nominal fee of ₹2.5 per SMS for this service";
                    this.broadcastHeading.type = "whatsapp";
                    this.broadcastHeading.button = "Broadcast Now";
                    break;
                case "krishify_chat":
                    this.broadcastHeading.heading =
                        "Broadcast users through Krishify Chat";
                    this.broadcastHeading.placeholder =
                        "Write your message here...";
                    this.broadcastHeading.note = "";
                    this.broadcastHeading.type = "krishify_chat";
                    this.broadcastHeading.button = "Broadcast Now";
                    break;
                default:
                    break;
            }
            this.broadcastDialog = true;
        },
    },

    components: {
        "brodcast-modal": broadcastModal,
        "followers-list": followersList,
        "farmer-details": farmerDetails,
        "custom-map": customMapFarmer,
    },
};
</script>

<style lang="scss" scoped>
.map-section {
    position: relative;
}
.components {
    position: absolute;
    bottom: 10px;
    align-items: flex-end;
    justify-content: flex-start;
    width: 94%;
}
.button-container {
    justify-content: flex-start;
    align-items: flex-start;
    width: 40%;
}
.button-container > div {
    margin: 0px 5px;
}
.button-container > div > div,
.my-followers-card {
    background-color: white;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 5px;
}
.components > div > div,
.my-followers-card {
    border-radius: 7px;
}
.my-followers-card {
    background-color: white;
    padding: 12px 15px;

    p {
        margin: 0;
        font-size: 0.9rem;
    }

    h4 {
        border-bottom: 2.7px solid #2eae6f;
        padding-bottom: 5px;
    }

    img {
        width: 30px;
        height: 30px;
    }
}
.all-followers-card {
    width: 40%;
    padding: 0px 5px;
    border-radius: 10px;
    height: calc(100vh - 130px);
    overflow: scroll;
    border-radius: 7px;
    background-color: #ffffff;
    margin-left: 8px;
}
.expand-icon {
    font-size: 1rem;
    background: #ebf5f0;
    padding: 8px 16px;
}
.v-icon {
    width: 10px;
    font-size: 1rem;
}

.add-btn {
    background: #ebf5f0;
    border-radius: 3px;
    font-size: 0.8rem;
    padding: 8px 12px;
}
.list-container {
    height: 120px;
    overflow-y: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.list {
    justify-content: flex-start;
    cursor: pointer;
}

.broadcast-card,
.product-card,
.my-farmers-card {
    height: 90.5px;
    width: 230px;
}
.broadcast {
    font-size: 1.7rem;
}
.product-card,
.my-farmers-card {
    padding: 10px 10px 0 12px;
}

.broadcast-card.active {
    background: linear-gradient(89.9deg, #308434 0.07%, #36993b 99.9%);
    width: 230px;
    h1 {
        color: white;
    }
}

.broadcast-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(89.9deg, #5ec263 0.07%, #36993b 99.9%);
}
.product-card img {
    width: 50px;
    height: 50px;
    margin-right: 5px;
}
.options > div {
    justify-content: flex-start;
}
.options img {
    width: 50px;
}
.options > div > div {
    background-color: white;
    width: 170px;
    padding: 15px 10px;
    box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07);
    border-radius: 8px;
    margin: 5px 10px;
}
</style>